class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      if (event.target && event.target.dataset && event.target.dataset.lcFilter) return;
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const w = document.getElementById('FacetsWrapperDesktop');
      if (w && w.dataset.largeCollection === 'true') return;
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const gridContainer = document.getElementById('ProductGridContainer');
    const collectionEl = gridContainer ? gridContainer.querySelector('.collection') : null;
    if (collectionEl) collectionEl.classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    const container = document.getElementById('ProductGridContainer');
    const parsed = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer');
    if (container && parsed) {
      container.innerHTML = parsed.innerHTML;
      document.dispatchEvent(new CustomEvent('product-grid:updated'));
    }
  }

  static renderProductCount(html) {
    const parsedCount = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount');
    if (!parsedCount) return;
    const count = parsedCount.innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    if (container) {
      container.innerHTML = count;
      container.classList.remove('loading');
    }
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      const target = document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`);
      if (target) target.innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      const target = document.querySelector(selector);
      if (!activeFacetsElement || !target) return;
      target.innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      const source = html.querySelector(selector);
      const target = document.querySelector(selector);
      if (!source || !target) return;
      target.innerHTML = source.innerHTML;
    });

    const mobileForm = document.getElementById('FacetFiltersFormMobile');
    if (mobileForm) {
      const menuDrawer = mobileForm.closest('menu-drawer');
      if (menuDrawer && menuDrawer.bindEvents) menuDrawer.bindEvents();
    }
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    if (event.target && event.target.dataset && event.target.dataset.lcFilter) return;
    const w = document.getElementById('FacetsWrapperDesktop');
    if (w && w.dataset.largeCollection === 'true') {
      if (typeof window.__lcFilterChange === 'function') window.__lcFilterChange();
      return;
    }
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'))
      this.onSubmitForm(searchParams, event)
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event)
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

(function() {
  var wrapper = document.getElementById('FacetsWrapperDesktop');
  var mobileForm = document.getElementById('FacetFiltersFormMobile');
  var isLargeCollection = (wrapper && wrapper.dataset.largeCollection === 'true') ||
                          (mobileForm && mobileForm.dataset.largeCollection === 'true');
  if (!isLargeCollection) return;

  var collectionHandle = (wrapper && wrapper.dataset.collectionHandle) ||
                         (mobileForm && mobileForm.dataset.collectionHandle) || '';
  if (!collectionHandle) return;

  var collectionTitle = (wrapper && wrapper.dataset.collectionTitle) ||
                        (mobileForm && mobileForm.dataset.collectionTitle) || collectionHandle;

  var sectionId = '';
  var productGrid = document.getElementById('product-grid');
  if (productGrid) sectionId = productGrid.dataset.id || '';

  var searchUrls = [
    '/search?type=product&q=' + encodeURIComponent('vendor:' + collectionTitle),
    '/search?type=product&q=' + encodeURIComponent('tag:' + collectionHandle),
    '/search?type=product&q=' + encodeURIComponent(collectionTitle) + '&options%5Bprefix%5D=last'
  ];
  var searchUrlIndex = 0;

  var activeFilters = {};
  var currentSearchParams = window.location.search.slice(1);

  function parseActiveFiltersFromURL() {
    activeFilters = {};
    var params = new URLSearchParams(window.location.search);
    params.forEach(function(value, key) {
      if (key.indexOf('filter.') === 0) {
        if (!activeFilters[key]) activeFilters[key] = [];
        activeFilters[key].push(value);
      }
    });
  }

  parseActiveFiltersFromURL();

  function buildDesktopFilterHTML(filters) {
    var html = '';
    var filterIndex = 0;

    for (var i = 0; i < filters.length; i++) {
      var filter = filters[i];
      filterIndex++;
      var dataIndex = 'lcf-' + filterIndex;

      if (filter.type === 'list' || filter.type === 'boolean') {
        var activeCount = 0;
        var activeKey = filter.param_name;
        if (activeFilters[activeKey]) activeCount = activeFilters[activeKey].length;

        html += '<details class="facets__disclosure-vertical lc-filter" data-index="' + dataIndex + '" open>';
        html += '<summary class="facets__summary caption-large focus-offset">';
        html += '<div><span>' + escapeHtml(filter.label);
        if (activeCount > 0) html += '<span class="facets__selected no-js-hidden"> (' + activeCount + ')</span>';
        html += '</span>';
        html += '<svg class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"/></svg>';
        html += '</div></summary>';

        html += '<div class="parent-display facets__display-vertical">';
        html += '<fieldset class="facets-wrap parent-wrap facets-wrap-vertical">';
        html += '<legend class="visually-hidden">' + escapeHtml(filter.label) + '</legend>';

        html += '<div class="facet-search-wrapper">';
        html += '<input type="text" class="facet-search" placeholder="Search..." onkeyup="filterFacetOptions(this)">';
        html += '<button type="button" class="facet-clear-btn" onclick="clearFacetSearch(this)" aria-label="Clear search">&times;</button>';
        html += '</div>';

        html += '<ul class="list-unstyled no-js-hidden" role="list">';
        for (var v = 0; v < filter.values.length; v++) {
          var val = filter.values[v];
          var isActive = activeFilters[activeKey] && activeFilters[activeKey].indexOf(val.value) !== -1;
          var isDisabled = val.count === 0 && !isActive;
          var showMoreClass = (v >= 10) ? ' show-more-item hidden' : '';

          html += '<li class="list-menu__item facets__item' + showMoreClass + '">';
          html += '<label for="LCFilter-' + filterIndex + '-' + v + '" class="facet-checkbox' + (isDisabled ? ' facet-checkbox--disabled' : '') + '">';
          html += '<input type="checkbox" name="' + escapeHtml(val.param_name || activeKey) + '" value="' + escapeHtml(val.value) + '"';
          html += ' id="LCFilter-' + filterIndex + '-' + v + '"';
          if (isActive) html += ' checked';
          if (isDisabled) html += ' disabled';
          html += ' data-lc-filter="true">';

          html += '<svg width="1.6rem" height="1.6rem" viewBox="0 0 16 16" aria-hidden="true" focusable="false">';
          html += '<rect width="16" height="16" stroke="currentColor" fill="none" stroke-width="1"></rect></svg>';
          html += '<svg class="icon icon-checkmark" width="1.1rem" height="0.7rem" viewBox="0 0 11 7" fill="none" xmlns="http://www.w3.org/2000/svg">';
          html += '<path d="M1.5 3.5L2.83333 4.75L4.16667 6L9.5 1" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/></svg>';

          html += '<span aria-hidden="true">' + escapeHtml(val.label) + ' (' + val.count + ')</span>';
          html += '<span class="visually-hidden">' + escapeHtml(val.label) + ' (' + val.count + ')</span>';
          html += '</label></li>';
        }
        html += '</ul>';
        html += '<p class="SearchNoResult" style="display:none; color:red;"></p>';
        html += '</fieldset>';

        if (filter.values.length > 10) {
          html += '<show-more-button>';
          html += '<button class="button-show-more link underlined-link no-js-hidden" id="Show-More-lcf-' + filterIndex + '" type="button">';
          html += '<span class="label-show-more label-text"><span aria-hidden="true">+ </span>Show more</span>';
          html += '<span class="label-show-less label-text hidden"><span aria-hidden="true">- </span>Show less</span>';
          html += '</button>';
          html += '</show-more-button>';
        }

        html += '</div></details>';

      } else if (filter.type === 'price_range') {
        html += '<details class="facets__disclosure-vertical lc-filter" data-index="' + dataIndex + '" open>';
        html += '<summary class="facets__summary caption-large focus-offset">';
        html += '<div><span>' + escapeHtml(filter.label) + '</span>';
        html += '<svg class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"/></svg>';
        html += '</div></summary>';

        html += '<div class="facets__display-vertical">';
        html += '<div class="facets__header-vertical">';
        html += '<span class="facets__selected">Max price: ' + formatMoney(filter.range_max) + '</span>';
        html += '</div>';
        html += '<price-range class="facets__price">';

        var minParamName = filter.min_value ? filter.min_value.param_name : (filter.param_name + '.gte');
        var maxParamName = filter.max_value ? filter.max_value.param_name : (filter.param_name + '.lte');
        var currentMin = '';
        var currentMax = '';
        var urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has(minParamName)) currentMin = urlParams.get(minParamName);
        if (urlParams.has(maxParamName)) currentMax = urlParams.get(maxParamName);

        html += '<div class="field"><input class="field__input" name="' + escapeHtml(minParamName) + '" type="number" placeholder="0" min="0"';
        if (currentMin) html += ' value="' + escapeHtml(currentMin) + '"';
        html += ' max="' + (filter.range_max / 100) + '" data-lc-filter="true">';
        html += '<label class="field__label">From</label></div>';

        html += '<div class="field"><input class="field__input" name="' + escapeHtml(maxParamName) + '" type="number" min="0"';
        if (currentMax) html += ' value="' + escapeHtml(currentMax) + '"';
        html += ' max="' + (filter.range_max / 100) + '" placeholder="' + (filter.range_max / 100) + '" data-lc-filter="true">';
        html += '<label class="field__label">To</label></div>';

        html += '</price-range>';
        html += '</div></details>';
      }
    }

    return html;
  }

  function buildMobileFilterHTML(filters) {
    var html = '';
    var filterIndex = 0;

    for (var i = 0; i < filters.length; i++) {
      var filter = filters[i];
      filterIndex++;
      var dataIndex = 'mobile-lcf-' + filterIndex;

      if (filter.type === 'list' || filter.type === 'boolean') {
        var activeKey = filter.param_name;

        html += '<details class="mobile-facets__details lc-filter" data-index="' + dataIndex + '">';
        html += '<summary class="mobile-facets__summary focus-inset"><div>';
        html += '<span>' + escapeHtml(filter.label) + '</span>';
        html += '<span class="mobile-facets__arrow no-js-hidden"><svg viewBox="0 0 14 10" fill="none" aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor"/></svg></span>';
        html += '</div></summary>';

        html += '<div class="mobile-facets__submenu gradient">';
        html += '<button class="mobile-facets__close-button link link--text focus-inset" aria-expanded="true" type="button">';
        html += '<svg viewBox="0 0 14 10" fill="none" aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor"/></svg>';
        html += escapeHtml(filter.label);
        html += '</button>';

        html += '<ul class="mobile-facets__list list-unstyled" role="list">';
        for (var v = 0; v < filter.values.length; v++) {
          var val = filter.values[v];
          var isActive = activeFilters[activeKey] && activeFilters[activeKey].indexOf(val.value) !== -1;
          var isDisabled = val.count === 0 && !isActive;

          html += '<li class="mobile-facets__item list-menu__item">';
          html += '<label for="LCFilterMobile-' + filterIndex + '-' + v + '" class="mobile-facets__label' + (isDisabled ? ' mobile-facets__label--disabled' : '') + '">';
          html += '<input class="mobile-facets__checkbox" type="checkbox" name="' + escapeHtml(val.param_name || activeKey) + '" value="' + escapeHtml(val.value) + '"';
          html += ' id="LCFilterMobile-' + filterIndex + '-' + v + '"';
          if (isActive) html += ' checked';
          if (isDisabled) html += ' disabled';
          html += ' data-lc-filter="true">';

          html += '<span class="mobile-facets__highlight"></span>';
          html += '<svg width="1.6rem" height="1.6rem" viewBox="0 0 16 16" aria-hidden="true" focusable="false"><rect width="16" height="16" stroke="currentColor" fill="none" stroke-width="1"></rect></svg>';
          html += '<svg class="icon icon-checkmark" width="1.1rem" height="0.7rem" viewBox="0 0 11 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.5 3.5L2.83333 4.75L4.16667 6L9.5 1" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/></svg>';

          html += '<span aria-hidden="true">' + escapeHtml(val.label) + ' (' + val.count + ')</span>';
          html += '</label></li>';
        }
        html += '</ul>';

        html += '<div class="no-js-hidden mobile-facets__footer gradient">';
        html += '<button type="button" class="no-js-hidden button button--primary" onclick="this.closest(\'.mobile-facets__wrapper\').querySelector(\'summary\').click()">Apply</button>';
        html += '</div>';

        html += '</div></details>';

      } else if (filter.type === 'price_range') {
        html += '<details class="mobile-facets__details lc-filter" data-index="' + dataIndex + '">';
        html += '<summary class="mobile-facets__summary focus-inset"><div>';
        html += '<span>' + escapeHtml(filter.label) + '</span>';
        html += '<span class="mobile-facets__arrow no-js-hidden"><svg viewBox="0 0 14 10" fill="none" aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor"/></svg></span>';
        html += '</div></summary>';

        html += '<div class="mobile-facets__submenu gradient">';
        html += '<button class="mobile-facets__close-button link link--text focus-inset" aria-expanded="true" type="button">';
        html += '<svg viewBox="0 0 14 10" fill="none" aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor"/></svg>';
        html += escapeHtml(filter.label);
        html += '</button>';

        html += '<p class="mobile-facets__info">Max price: ' + formatMoney(filter.range_max) + '</p>';
        html += '<price-range class="facets__price">';

        var minPN = filter.min_value ? filter.min_value.param_name : (filter.param_name + '.gte');
        var maxPN = filter.max_value ? filter.max_value.param_name : (filter.param_name + '.lte');

        html += '<div class="field"><input class="field__input" name="' + escapeHtml(minPN) + '" type="number" placeholder="0" min="0" inputmode="decimal" data-lc-filter="true">';
        html += '<label class="field__label">From</label></div>';
        html += '<div class="field"><input class="field__input" name="' + escapeHtml(maxPN) + '" type="number" min="0" inputmode="decimal" placeholder="' + (filter.range_max / 100) + '" data-lc-filter="true">';
        html += '<label class="field__label">To</label></div>';

        html += '</price-range>';

        html += '<div class="no-js-hidden mobile-facets__footer">';
        html += '<button type="button" class="no-js-hidden button button--primary" onclick="this.closest(\'.mobile-facets__wrapper\').querySelector(\'summary\').click()">Apply</button>';
        html += '</div>';

        html += '</div></details>';
      }
    }
    return html;
  }

  function escapeHtml(str) {
    if (!str) return '';
    return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function formatMoney(cents) {
    if (typeof cents !== 'number') return cents;
    return (cents / 100).toFixed(2);
  }

  function collectFilterParams() {
    var params = new URLSearchParams();
    var sortSelect = document.querySelector('#SortBy');
    if (sortSelect && sortSelect.value) params.set('sort_by', sortSelect.value);

    document.querySelectorAll('[data-lc-filter]').forEach(function(input) {
      if (input.type === 'checkbox') {
        if (input.checked && input.name && input.value) {
          params.append(input.name, input.value);
        }
      } else if (input.type === 'number') {
        if (input.value && input.name) {
          params.append(input.name, input.value);
        }
      }
    });

    return params.toString();
  }

  function handleLCFilterChange() {
    var searchParams = collectFilterParams();

    var gridContainer = document.getElementById('ProductGridContainer');
    var collectionEl = gridContainer ? gridContainer.querySelector('.collection') : null;
    if (collectionEl) collectionEl.classList.add('loading');

    var countContainer = document.getElementById('ProductCount');
    var countContainerDesktop = document.getElementById('ProductCountDesktop');
    if (countContainer) countContainer.classList.add('loading');
    if (countContainerDesktop) countContainerDesktop.classList.add('loading');

    history.pushState(
      { searchParams: searchParams },
      '',
      window.location.pathname + (searchParams ? '?' + searchParams : '')
    );
    parseActiveFiltersFromURL();

    var hasFilters = searchParams && searchParams.indexOf('filter.') !== -1;

    if (hasFilters) {
      var filterParamStr = '';
      searchParams.split('&').forEach(function(p) {
        if (p.indexOf('filter.') === 0 || p.indexOf('sort_by') === 0) {
          filterParamStr += '&' + p;
        }
      });

      var searchFetchUrl = searchUrls[searchUrlIndex] + filterParamStr;

      fetch(searchFetchUrl)
        .then(function(r) { return r.text(); })
        .then(function(html) {
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var searchGrid = parsed.getElementById('ProductGridContainer');
          if (searchGrid && gridContainer) {
            gridContainer.innerHTML = searchGrid.innerHTML;
            document.dispatchEvent(new CustomEvent('product-grid:updated'));
          }

          var productCount = 0;
          var gridItems = parsed.querySelectorAll('#product-grid .grid__item');
          if (gridItems.length > 0) productCount = gridItems.length;

          var searchCountEl = parsed.getElementById('ProductCountDesktop') || parsed.getElementById('ProductCount');
          if (searchCountEl) {
            var countText = searchCountEl.textContent || '';
            var countNum = countText.match(/(\d+)/);
            if (countNum) productCount = parseInt(countNum[1], 10);
          }

          var countHtml = productCount + ' product' + (productCount !== 1 ? 's' : '');
          if (countContainer) {
            countContainer.innerHTML = countHtml;
            countContainer.classList.remove('loading');
          }
          if (countContainerDesktop) {
            countContainerDesktop.innerHTML = countHtml;
            countContainerDesktop.classList.remove('loading');
          }

          var filters = parseSearchFilters(html);
          if (filters.length > 0) {
            renderFiltersToPlaceholders(filters);
          }
        })
        .catch(function(err) {
          if (collectionEl) collectionEl.classList.remove('loading');
          if (countContainer) countContainer.classList.remove('loading');
          if (countContainerDesktop) countContainerDesktop.classList.remove('loading');
        });
    } else {
      var collectionUrl = window.location.pathname + '?section_id=' + sectionId;
      fetch(collectionUrl)
        .then(function(r) { return r.text(); })
        .then(function(html) {
          FacetFiltersForm.renderProductGridContainer(html);
          FacetFiltersForm.renderProductCount(html);
          refreshSearchFilters();
        })
        .catch(function(err) {
          if (collectionEl) collectionEl.classList.remove('loading');
        });
    }
  }

  var lcDebounceTimer = null;
  function debouncedLCFilterChange() {
    if (lcDebounceTimer) clearTimeout(lcDebounceTimer);
    lcDebounceTimer = setTimeout(function() {
      lcDebounceTimer = null;
      handleLCFilterChange();
    }, 500);
  }
  window.__lcFilterChange = debouncedLCFilterChange;

  function bindFilterEvents() {
    document.querySelectorAll('[data-lc-filter]').forEach(function(input) {
      if (input.__lcBound) return;
      input.__lcBound = true;

      if (input.type === 'checkbox') {
        input.addEventListener('change', function(e) {
          e.stopPropagation();
          debouncedLCFilterChange();
        });
      } else if (input.type === 'number') {
        input.addEventListener('change', function(e) {
          e.stopPropagation();
          debouncedLCFilterChange();
        });
      }
    });
  }

  function parseSearchFilters(html) {
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var filters = [];

    var filterElements = parsed.querySelectorAll('.facets__disclosure-vertical, .facets__disclosure');
    filterElements.forEach(function(el) {
      var summarySpan = el.querySelector('summary span');
      if (!summarySpan) return;

      var label = summarySpan.textContent.trim().replace(/\s*\(\d+\)$/, '');

      var priceRange = el.querySelector('price-range');
      if (priceRange) {
        var minInput = priceRange.querySelector('input[name*=".gte"], input[name*="price_min"]');
        var maxInput = priceRange.querySelector('input[name*=".lte"], input[name*="price_max"]');
        var rangeMax = 0;
        if (maxInput) {
          var maxAttr = maxInput.getAttribute('max') || maxInput.getAttribute('placeholder') || '0';
          rangeMax = parseFloat(maxAttr) * 100;
        }
        filters.push({
          type: 'price_range',
          label: label,
          param_name: 'filter.v.price',
          range_max: rangeMax,
          min_value: { param_name: minInput ? minInput.name : 'filter.v.price.gte' },
          max_value: { param_name: maxInput ? maxInput.name : 'filter.v.price.lte' }
        });
        return;
      }

      var checkboxes = el.querySelectorAll('input[type="checkbox"]');
      if (checkboxes.length === 0) return;

      var paramName = checkboxes[0].name || '';
      var values = [];

      checkboxes.forEach(function(cb) {
        var li = cb.closest('li');
        var spanEl = li ? li.querySelector('span[aria-hidden="true"]') : null;
        var labelText = '';
        var count = 0;

        if (spanEl) {
          var rawText = spanEl.textContent.trim();
          var countMatch = rawText.match(/\((\d+)\)\s*$/);
          if (countMatch) {
            count = parseInt(countMatch[1], 10);
            labelText = rawText.replace(/\s*\(\d+\)\s*$/, '');
          } else {
            labelText = rawText;
          }
        }

        values.push({
          value: cb.value,
          label: labelText || cb.value,
          count: count,
          param_name: cb.name || paramName,
          active: cb.checked
        });
      });

      filters.push({
        type: 'list',
        label: label,
        param_name: paramName,
        values: values
      });
    });

    return filters;
  }

  function refreshSearchFilters() {
    var filterParams = '';
    var params = new URLSearchParams(window.location.search);
    params.forEach(function(value, key) {
      if (key.indexOf('filter.') === 0) {
        filterParams += '&' + encodeURIComponent(key) + '=' + encodeURIComponent(value);
      }
    });

    function trySearchUrl(idx) {
      if (idx >= searchUrls.length) {
        showFilterLoadError();
        return;
      }

      var url = searchUrls[idx] + (filterParams ? '&' + filterParams.replace(/^&/, '') : '');

      fetch(url)
        .then(function(r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.text();
        })
        .then(function(html) {
          var filters = parseSearchFilters(html);
          if (filters.length > 0) {
            searchUrlIndex = idx;
            renderFiltersToPlaceholders(filters);
          } else {
            trySearchUrl(idx + 1);
          }
        })
        .catch(function() {
          trySearchUrl(idx + 1);
        });
    }

    if (searchUrlIndex > 0 && filterParams) {
      var url = searchUrls[searchUrlIndex] + '&' + filterParams.replace(/^&/, '');
      fetch(url)
        .then(function(r) { return r.text(); })
        .then(function(html) {
          var filters = parseSearchFilters(html);
          if (filters.length > 0) {
            renderFiltersToPlaceholders(filters);
          } else {
            trySearchUrl(0);
          }
        })
        .catch(function() { trySearchUrl(0); });
    } else {
      trySearchUrl(0);
    }
  }

  function showFilterLoadError() {
    var desktopPlaceholder = document.getElementById('LargeCollectionFiltersPlaceholder');
    if (desktopPlaceholder) {
      desktopPlaceholder.classList.remove('large-collection-filters-loading');
      desktopPlaceholder.innerHTML = '<p style="padding:10px 0;color:#666;font-size:1.3rem;">Filters could not be loaded for this collection.</p>';
    }
    var mobilePlaceholder = document.getElementById('LargeCollectionMobileFiltersPlaceholder');
    if (mobilePlaceholder) {
      mobilePlaceholder.classList.remove('large-collection-filters-loading');
      mobilePlaceholder.innerHTML = '<p style="padding:10px 0;color:#666;font-size:1.3rem;">Filters could not be loaded.</p>';
    }
  }

  function renderFiltersToPlaceholders(filters) {
    var desktopPlaceholder = document.getElementById('LargeCollectionFiltersPlaceholder');
    if (desktopPlaceholder) {
      var desktopHTML = buildDesktopFilterHTML(filters);
      desktopPlaceholder.innerHTML = desktopHTML;
      desktopPlaceholder.classList.remove('large-collection-filters-loading');

      if (!document.querySelector('#verticalTitle')) {
        var heading = document.createElement('h2');
        heading.className = 'facets__heading facets__heading--vertical caption-large text-body';
        heading.id = 'verticalTitle';
        heading.tabIndex = -1;
        heading.textContent = 'Filter:';
        desktopPlaceholder.insertBefore(heading, desktopPlaceholder.firstChild);
      }
    }

    var mobilePlaceholder = document.getElementById('LargeCollectionMobileFiltersPlaceholder');
    if (mobilePlaceholder) {
      var mobileHTML = buildMobileFilterHTML(filters);
      mobilePlaceholder.innerHTML = mobileHTML;
      mobilePlaceholder.classList.remove('large-collection-filters-loading');
    }

    bindFilterEvents();

    if (typeof bindFacetInputs === 'function') {
      try { bindFacetInputs(); } catch(e) {}
    }

    setTimeout(function() {
      document.dispatchEvent(new CustomEvent('lc-filters:rendered'));
    }, 100);
  }

  window.addEventListener('popstate', function(event) {
    if (!isLargeCollection) return;
    parseActiveFiltersFromURL();

    var searchParams = window.location.search.slice(1);
    var gridContainer = document.getElementById('ProductGridContainer');
    var collectionEl = gridContainer ? gridContainer.querySelector('.collection') : null;
    if (collectionEl) collectionEl.classList.add('loading');

    var hasFilters = searchParams && searchParams.indexOf('filter.') !== -1;

    if (hasFilters) {
      var filterParamStr = '';
      searchParams.split('&').forEach(function(p) {
        if (p.indexOf('filter.') === 0 || p.indexOf('sort_by') === 0) {
          filterParamStr += '&' + p;
        }
      });

      var popSearchUrl = searchUrls[searchUrlIndex] + filterParamStr;
      fetch(popSearchUrl)
        .then(function(r) { return r.text(); })
        .then(function(html) {
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var searchGrid = parsed.getElementById('ProductGridContainer');
          if (searchGrid && gridContainer) {
            gridContainer.innerHTML = searchGrid.innerHTML;
            document.dispatchEvent(new CustomEvent('product-grid:updated'));
          }
          var productCount = 0;
          var gridItems = parsed.querySelectorAll('#product-grid .grid__item');
          if (gridItems.length > 0) productCount = gridItems.length;
          var searchCountEl = parsed.getElementById('ProductCountDesktop') || parsed.getElementById('ProductCount');
          if (searchCountEl) {
            var cMatch = (searchCountEl.textContent || '').match(/(\d+)/);
            if (cMatch) productCount = parseInt(cMatch[1], 10);
          }
          var cHtml = productCount + ' product' + (productCount !== 1 ? 's' : '');
          var countContainer = document.getElementById('ProductCount');
          var countContainerDesktop = document.getElementById('ProductCountDesktop');
          if (countContainer) { countContainer.innerHTML = cHtml; countContainer.classList.remove('loading'); }
          if (countContainerDesktop) { countContainerDesktop.innerHTML = cHtml; countContainerDesktop.classList.remove('loading'); }

          var filters = parseSearchFilters(html);
          if (filters.length > 0) renderFiltersToPlaceholders(filters);
        })
        .catch(function() {
          if (collectionEl) collectionEl.classList.remove('loading');
        });
    } else {
      var collectionUrl = window.location.pathname + '?section_id=' + sectionId;
      fetch(collectionUrl)
        .then(function(r) { return r.text(); })
        .then(function(html) {
          FacetFiltersForm.renderProductGridContainer(html);
          FacetFiltersForm.renderProductCount(html);
          refreshSearchFilters();
        })
        .catch(function() {
          if (collectionEl) collectionEl.classList.remove('loading');
        });
    }
  });

  refreshSearchFilters();
})();
































